import React, {useDebugValue} from 'react';

import classNames from 'classnames';

import {Button as ButtonDefault, ButtonPrimary} from '@homeaway/react-buttons';

// ButtonDefault.whyDidYouRender = true;
// ButtonPrimary.whyDidYouRender = true;

import {useSearchFormContext} from '../../../hooks/useSearchFormContext';

import {hasCheckAvailabilitySubmitActionType, showSubmitIcon, showSubmitDetailsPrimaryAction} from '../../../utils/submit';

import {SearchIcon} from '../../SearchIcon/SearchIcon';

const classNamespace = 'search-form';
const fieldClassName = `${classNamespace}__field`;
const buttonFieldClassName = `${classNamespace}__button-field`;
const detailsFieldClassName = `${classNamespace}__details-field`;
const detailsButtonFieldClassName = `${classNamespace}__details-button-field`;
const submitDetailsButtonFieldClassName = `${classNamespace}__submit-details-button-field`;

// eslint-disable-next-line complexity
function useComponent() {
    const {
        mediaSettings,
        formOptions,
        formSettings: {
            hasLoaded,
            isSubmitting
        },
        submitEvents: {
            onClick: onSubmitClick
        },
        submitOptions,
        submitOptions: {
            iconName
        },
        submitTranslations: {
            checkAvailabilityLabelText,
            searchLabelText
        },
        submitDetailsEvents: {
            onClick: onSubmitDetailsClick
        }
    } = useSearchFormContext();

    const className = classNames(fieldClassName, buttonFieldClassName, detailsFieldClassName, detailsButtonFieldClassName, submitDetailsButtonFieldClassName);

    const Button = (
        showSubmitDetailsPrimaryAction(mediaSettings, formOptions, submitOptions)
            ? ButtonPrimary
            : ButtonDefault
    );

    const type = 'submit';

    const labelIcon = showSubmitIcon(formOptions, submitOptions) && (
        <SearchIcon name={iconName}/>
    ) || null;

    const labelText = (
        hasCheckAvailabilitySubmitActionType(submitOptions)
            ? checkAvailabilityLabelText
            : searchLabelText
    );

    const label = (
        <>
            {labelIcon}
            <span>{labelText}</span>
        </>
    );

    const disabled = !hasLoaded || isSubmitting;
    const loading = hasLoaded && isSubmitting;

    function handleClick(...args) {
        onSubmitClick(...args);
        onSubmitDetailsClick(...args);
    }

    const result = {
        className,
        Button,
        type,
        label,
        disabled,
        loading,
        onClick: handleClick
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
